import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createAppStore, getPersistor, ApiUrls } from '@ideoz/core';
import { default as apiClient } from '@ideoz/core/api/client';
import { initAnalytics } from '@ideoz/core/analytics';
import App from './App';
import './index.scss';
import mixpanel from "mixpanel-browser";

// Initialize Mixpanel if available
if (mixpanel && typeof mixpanel.init === 'function') {
  mixpanel.init('1eaf3142c2840678916603b92c51fc01', {
    autocapture: true,
    track_pageview: true,
    record_sessions_percent: 100, // records 100% of all sessions
    record_heatmap_data: true,
    record_mask_all_text: false, // disables masking for all elements
  });
}

// Create Redux store
const store = createAppStore();
const persistor = getPersistor(store);

// Initialize analytics service
initAnalytics(apiClient, ApiUrls.events, () => store.getState() as any);

const rootElement = document.getElementById('root');

if (rootElement) {
  // Store the root instance on the element to persist across HMR updates
  if (!(rootElement as any)._reactRoot) {
    (rootElement as any)._reactRoot = ReactDOM.createRoot(rootElement);
  }
  (rootElement as any)._reactRoot.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}
